import { Show, SimpleShowLayout, TextField } from 'react-admin'

const GroupShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="name" emptyText="N/A" />
      </SimpleShowLayout>
    </Show>
  )
}

export default GroupShow
